// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1-twY","savePackageButton":"ClientWallet_savePackageButton__3Hm0O"};